import { render, staticRenderFns } from "./ForgetPwd.vue?vue&type=template&id=74b338ba&scoped=true&"
import script from "./ForgetPwd.vue?vue&type=script&lang=js&"
export * from "./ForgetPwd.vue?vue&type=script&lang=js&"
import style0 from "./ForgetPwd.vue?vue&type=style&index=0&id=74b338ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b338ba",
  null
  
)

export default component.exports